import styled from 'styled-components';

export const Gradient = styled.div`
    background: linear-gradient(0deg, transparent, rgba(0, 168, 142, 0.1) 80%) no-repeat;
`;
